import { Navigate, Route, Routes } from 'react-router-dom';

import { AuthProvider } from './auth/AuthContext';
import { ProtectedRoute } from './auth/ProtectedRoute';
import AdminLayout from './admin/AdminLayout';
import AdminCaptainsListPage from './admin/AdminCaptainsListPage';
import AdminCaptainFormPage from './admin/AdminCaptainFormPage';
import AdminLoginPage from './pages/AdminLoginPage';
import PublicCaptainPage from './pages/PublicCaptainPage';

/**
 * Top-level route table for the captain-qr-profile SPA.
 *
 * Public routes:
 *  - `/captain/:id` — public captain profile (Req 1.1)
 *
 * Admin routes (all guarded by `<ProtectedRoute>` + `<AdminLayout>`):
 *  - `/admin` — captains list (Req 8.1)
 *  - `/admin/captains/new` — create form (Req 5.8)
 *  - `/admin/captains/:id/edit` — edit form (Req 6.7)
 *
 * `/admin/login` is rendered outside the protected layout so an
 * unauthenticated user can access it.
 *
 * Anything else falls back to `/captain/:id` is invalid → routes to
 * `/admin/login` is misleading; instead route to a generic 404 message.
 */
export default function App(): JSX.Element {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/admin" replace />}
        />

        <Route path="/captain/:id" element={<PublicCaptainPage />} />

        <Route path="/admin/login" element={<AdminLoginPage />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminCaptainsListPage />} />
            <Route
              path="/admin/captains/new"
              element={<AdminCaptainFormPage />}
            />
            <Route
              path="/admin/captains/:id/edit"
              element={<AdminCaptainFormPage />}
            />
          </Route>
        </Route>

        <Route
          path="*"
          element={
            <div
              dir="rtl"
              style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily:
                  'system-ui, -apple-system, "Segoe UI", Tahoma, Arial, sans-serif',
              }}
            >
              الصفحة غير موجودة
            </div>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
